import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createDateRangeFieldValidationSuite(
  definition: TextField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as {
    start: string;
    end: string;
  };

  test(
    createFieldName(definition),
    trans("form_validation.dateRange.start"),
    () => {
      enforce(value.start).isString().isNotEmpty();
    },
  );

  test(
    createFieldName(definition),
    trans("form_validation.dateRange.end"),
    () => {
      enforce(value.end).isString().isNotEmpty();
    },
  );
}
